import { GET_OPEN_JOBS, GET_OPEN_JOBS_SUCCESS, GET_OPEN_JOBS_FAILURE } from "./actionTypes";

export const getOpenJobs = queryParameters => {
    return {
        type: GET_OPEN_JOBS,
        payload: { queryParameters },
    }
}
export const getOpenJobsSuccess = jobs => {
    return {
        type: GET_OPEN_JOBS_SUCCESS,
        payload: { jobs },
    }
}
export const getOpenJobsFailed = errorMessage => {
    return {
        type: GET_OPEN_JOBS_FAILURE,
        payload: { errorMessage },
    }
}